import React, { useEffect, useState } from 'react'
// import { useHistory } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import styles from './login.module.scss'
import { auth, database, databaseRef } from '../../../utils/firebase'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { set } from 'firebase/database'
import FormikForm from '../../../components/FormikForm/FormikForm'
import FieldFactory from '../../../components/FormikForm/FieldFactory'
import Spinner from '../../../components/Spinner'
import { path } from '../../../utils/const'
import { setUserIP } from 'slices/app.slice'
import { addDoctorLog } from 'utils/functions'

const Login = () => {
  // const history = useHistory()
  const dispatch = useDispatch()
  const [initialValues, setInitialValues] = useState(null)
  const [initialTouched, setInitialTouched] = useState(null)
  const [fieldData, setFieldData] = useState([])
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  const [pageLoading, setPageLoading] = useState(false)
  useEffect(() => {
    let newFieldData = [
      {
        slug: 'email',
        type: 'text',
        label: 'Email ',
        name: 'email',
        validations: ['required', 'email'],
      },
      {
        slug: 'password',
        type: 'password',
        label: 'Password',
        name: 'password',
        validations: ['required'],
      },
    ]
    const { values, touched } = getDefaultValues(newFieldData)
    setFieldData(newFieldData)
    setInitialValues(values)
    setInitialTouched(touched)
  }, [])

  const getDefaultValues = (fieldInfos) => {
    let defValues = {}
    let defInitialsTouches = {}
    fieldInfos?.forEach((fieldInfo) => {
      switch (fieldInfo.type) {
        case 'text':
        case 'textarea':
          defValues[fieldInfo.slug] = ''
          break
        case 'phone':
          defValues[fieldInfo.slug] = ''
          break
        case 'password':
          defValues[fieldInfo.slug] = ''
          break
        case 'date':
          defValues[fieldInfo.slug] = ''
          break
        case 'number':
          defValues[fieldInfo.slug] = 0
          break
        case 'image':
          defValues[fieldInfo.slug] = null
          break
        case 'checklist':
          defValues[fieldInfo.slug] = []
          break
        case 'horizontal_check_box':
          defValues[fieldInfo.slug] = null
          break
        case 'vertical_check_list':
          defValues[fieldInfo.slug] = []
          break
        default:
          break
      }
    })
    console.log('defValues ', defValues)
    return { values: defValues, touched: defInitialsTouches }
  }

  const renderFormFields = (fieldInfos, formikProps) => {
    const res = fieldInfos?.map((fieldInfo, index) => {
      if (fieldInfo.row && fieldInfo.rowIndex === 0) {
        return (
          <div
            className={styles.formRow}
            key={`${fieldInfo.slug}_${fieldInfo.row}_${fieldInfo.rowIndex}`}
          >
            {FieldFactory.getFormField(fieldInfo, formikProps)}
            <div style={{ width: 40 }}></div>
            {FieldFactory.getFormField(fieldInfos[index + 1], formikProps)}
          </div>
        )
      } else {
        return FieldFactory.getFormField(fieldInfo, formikProps)
      }
    })
    return res
  }

  const getIP = (callback) => {
    fetch('https://api.ipify.org?format=json', { mode: 'cors' })
      .then((resp) => resp.json())
      .then((myip) => {
        console.log('myip ', myip)
        callback(myip.ip)
      })
      .catch(err => {
        console.log('fetch ip error', err)
        fetch('https://ipv4.jsonip.com', { mode: 'cors' })
          .then((resp) => resp.json())
          .then((myip) => {

            console.log('myip ', myip)
            callback(myip.ip)
          })
          .catch(err => {
            console.log('fetch ip error', err)
            return callback(null)
          })
      })
  }

  const Login = async (values) => {
    setLoading(true)
    signInWithEmailAndPassword(auth, values.email, values.password)
      .then((data) => {
        // 2. Fetch IP and store in Redux
        getIP((ip) => {
          if (ip) {
            dispatch(setUserIP(ip));
            console.log("✅ IP address stored in Redux:", ip);

            addDoctorLog({
              action: 'LOGIN',
              category: 'session',
              doctorID: data?.user?.uid || "",
              description: 'Doctor logged in',
              // ipAddress: ip || 'unknown',
              details: {
                timestamp: Date.now(),
                ip: ip || ''
              }
            })
          } else {
            console.warn("⚠️ Could not retrieve IP address.");
          }
        });

        // add key with doctors/uid/online to true
        const userRef = databaseRef(database, `doctors/${data?.user?.uid}/online`)
        set(userRef, true)
        setApiError('')
        setLoading(false)
      })
      .catch((error) => {
        setApiError(error.message)
        setLoading(false)
      })
  }
  const onForgotPasswordClicked = () => {
    // history.push(path.resetPassword)
  }
  return (
    <div className={styles.root}>
      <span className={styles.title}>
        Your Doctors Online Information System
      </span>
      {pageLoading ? (
        <Spinner size="4rem" color="black" isLoading />
      ) : (
        <FormikForm
          fieldInfos={fieldData}
          initialValue={initialValues}
          initialTouched={initialTouched}
          renderFormFields={renderFormFields}
          onSubmit={Login}
          formButtonRow={styles.formButtonRow}
          tpBG={styles.tpBG}
          submitBtnClass={styles.loginButton}
          submitBtnLabel="Sign In"
          submitBtnClassDisabled={styles.submitBtnClassDisabled}
          onAdditionalButtonClicked={onForgotPasswordClicked}
          // showForgotPassword
          submitButtonKey="loginButton"
          loading={loading}
        />
      )}
      <div className={styles.error}>{apiError}</div>
    </div>
  )
}

Login.propTypes = {}
Login.defaultProps = {}

export default Login
